
export const BaseUrl = location.href.indexOf('/www/') >= 0 ? location.href.substr(0,location.href.indexOf('/www/')) + '/www/' : '/'
__webpack_public_path__ = BaseUrl





// WEBPACK FOOTER //
// ./src/BaseUrl.js